import { toast } from 'react-toastify';
import { ContractWeb3 } from '@amfi/connect-wallet/dist/interface';
import { contractsConfig, ContractsNames } from 'services/WalletService/config/index';
import { error, request, success } from 'store/api/actions';
import networkSelector from 'store/network/selectors';
import userSelector from 'store/user/selectors';
import { call, put, select, takeLatest } from 'typed-redux-saga';
import { Chains, IChainType } from 'types';
import { getMaxGas, logger } from 'utils';

import { approveRedeemOrClaim } from '../actions';
import actionTypes from '../actionTypes';

export function* approveRedeemOrClaimSaga({
  type,
  payload: { isSingle, collectionAddress, web3Provider },
}: ReturnType<typeof approveRedeemOrClaim>) {
  const { contracts } = contractsConfig;

  yield put(request(type));

  const { address, chainType, network }: { address: string; chainType: IChainType; network: Chains } = yield select(
    userSelector.getUser,
  );
  const { redeemAddress } = yield select(networkSelector.getNetwork);

  try {
    const collectionAbi = contracts[isSingle ? ContractsNames.erc721 : ContractsNames.erc1155][chainType].abi[network];
    const collectionContract: ContractWeb3 = yield new web3Provider.eth.Contract(collectionAbi, collectionAddress);

    const isApproved: boolean = yield call(collectionContract.methods.isApprovedForAll(address, redeemAddress).call);

    if (isApproved) {
      yield put(success(type));
      return;
    }

    const { maxFeePerGas, maxPriorityFeePerGas } = yield* call(getMaxGas);
    yield call(collectionContract.methods.setApprovalForAll(redeemAddress, true).send, {
      from: address,
      maxFeePerGas,
      maxPriorityFeePerGas,
    });

    yield put(success(type));
  } catch (err) {
    logger('Approve redeem or claim', err);
    yield put(error(type, err));
    toast.error('Something went wrong');
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.APPROVE_REDEEM_OR_CLAIM, approveRedeemOrClaimSaga);
}
